import { render, staticRenderFns } from "./MyProfileDetailsNew.vue?vue&type=template&id=311be6be&scoped=true&"
import script from "./MyProfileDetailsNew.vue?vue&type=script&lang=ts&"
export * from "./MyProfileDetailsNew.vue?vue&type=script&lang=ts&"
import style0 from "./MyProfileDetailsNew.vue?vue&type=style&index=0&id=311be6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311be6be",
  null
  
)

export default component.exports